export function requireNonNull<T>(
  value: T,
  message = "Expected value to be non-null"
): NonNullable<T> {
  if (value == null) {
    throw new Error(message)
  }
  return value
}
